"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getListFromType = function getListFromType(type) {
  switch (type) {
    case 'ordered':
      return 'ol';

    case 'description':
      return 'dl';

    case 'unordered':
    case 'linked':
    case 'icon':
    default:
      return 'ul';
  }
};

var propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['normal', 'small', 'tiny']),
  type: _propTypes["default"].oneOf(['unordered', 'ordered', 'linked', 'description', 'icon'])
};
var defaultProps = {
  size: 'normal',
  type: 'unordered'
};

var List = function List(props) {
  var className = props.className,
      type = props.type,
      size = props.size,
      children = props.children,
      otherProps = _objectWithoutPropertiesLoose(props, ["className", "type", "size", "children"]);

  var classes = (0, _classnames["default"])('grv-list__list', "grv-list__list--" + size, {
    'grv-list--icon': type === 'icon',
    'grv-list__list--description': type === 'description',
    'grv-list__list--linked': type === 'linked'
  }, className);
  var listTag = getListFromType(type);
  return /*#__PURE__*/_react["default"].createElement(listTag, Object.assign({
    className: classes
  }, otherProps), children);
};

List.propTypes = propTypes;
List.defaultProps = defaultProps;
List.Item = _ListItem["default"];
var _default = List;
exports["default"] = _default;